import React, { FC, forwardRef } from 'react';
import { Input, InputRef } from 'antd';
import cx from 'classnames';
import { InputProps } from 'antd/lib/input/Input';
import { setDash } from '../../../lib/common';

export interface CustomInputProps extends Omit<InputProps, 'onChange'> {
  onChange?: (value: string) => void;
  isEditable?: boolean;
  alterForm?: React.ReactNode;
  rex?: RegExp;
}

const CustomInput: FC<CustomInputProps> = forwardRef<InputRef, CustomInputProps>((props, ref) => {
  const { className, onChange, isEditable = true, value, maxLength, alterForm, rex, ...res } = props;

  return (
    <>
      {isEditable ? (
        <Input
          className={cx('amondz-input', className)}
          onChange={(e) => {
            let value = e.target.value;

            /**
             *  정규식이 있는 경우에는 정규식을 통과한 값만 입력됨
             */
            if (rex) {
              const strList = value.split('').reduce((acc, str) => {
                rex.test(str) && acc.push(str);
                return acc;
              }, [] as string[]);
              value = strList.join('');
            }

            /**
             * 한글인 경우 maxlength를 한글자 초과할수 있는 문제 수정
             */
            if (maxLength && value.length > maxLength) {
              value = value.slice(0, maxLength);
            }

            onChange && onChange(value);
          }}
          value={value}
          ref={ref}
          {...res}
        />
      ) : /**
       * 읽기전용인 경우 편집을 할 수 없도록 해야함.
       * alterForm props 가 있다면 alterForm 을 사용하여 보이도록 하고,
       * 아닌 경우에는 div 태그를 사용해서 보이도록 함
       */
      alterForm && value ? (
        alterForm
      ) : (
        <div className="read-only-contents">{setDash(value)}</div>
      )}
    </>
  );
});

CustomInput.displayName = 'CustomInput';

export default CustomInput;
